<script lang="ts">
  import GenericUploadTask from "./GenericUploadTask.svelte";
  import CheckboxGroup from "../components/CheckboxGroup.svelte";

  let {
    action,
    taskTitle,
    taskQuestion,
    documentName,
    createUploadSessionUrl,
    uploadAttachmentExtensions,
    errors,
    damagesOptions,
  }: {
    action: string;
    taskTitle: string;
    taskQuestion: string;
    documentName: string;
    createUploadSessionUrl: string;
    uploadAttachmentExtensions: string[];
    errors: { [key: string]: string } | null;
    damagesOptions: [string, string][]
  } = $props();
</script>

<GenericUploadTask
  {action}
  {taskTitle}
  {taskQuestion}
  {documentName}
  {createUploadSessionUrl}
  {uploadAttachmentExtensions}
  {errors}
>
  <fieldset class="ui-fieldset mt-6">
    <legend>What kind of damage(s) was it?</legend>
    <CheckboxGroup
      name="damages"
      options={damagesOptions}
    />
  </fieldset>
</GenericUploadTask>
